export enum LogoTypes {
	SUNNY = 'SUNNY',
	NONE = 'NONE',
	CUSTOM = 'CUSTOM',
}

export type Logo = LogoTypes.SUNNY | LogoTypes.NONE | LogoTypes.CUSTOM;
